import { useChurch } from '../context/ChurchContext';

// Vue globale = superadmin plateforme sur « Vue globale » (aucune église
// sélectionnée) : les listes mélangent alors toutes les églises, chaque ligne
// doit donc indiquer son église (RCC-SEC-001).
export default function useGlobalView() {
  const { isPlatformAdmin, selectedChurchId } = useChurch();
  return isPlatformAdmin && selectedChurchId === null;
}
